import {
  OranizationSubscriptionType,
  OrgType,
  SelfServePlan,
  SelfServeSubscriptionTypes,
} from '@hcs/types';
import { capitalizeFirstLetter } from '@hcs/utils';

export const getPlanSubscriptionType = (
  plan: SelfServePlan,
): SelfServeSubscriptionTypes =>
  `${capitalizeFirstLetter(plan.planTierKey)}-${plan.commit_period}`;

export const getOrgSubscriptionType = (
  type: OrgType | undefined,
  plan?: SelfServePlan,
): OranizationSubscriptionType | undefined =>
  plan ? getPlanSubscriptionType(plan) : type;
